import classNames from "classnames"
import { FC } from "react"
import { useDispatch } from "react-redux"

// components
import SupportWidget from "../SupportWidget/SupportWidget"

// utils
import { openChat } from "./LiveChatUtils"

import * as styles from "../../pages/{ContentfulHelpArticle.node_locale}/contact-us.module.scss"

type Props = {
  primaryText: React.ReactNode
  secondaryText: React.ReactNode
  icon: React.ReactNode
  recommended?: boolean
  withinBusinessHours: boolean
  disabled: boolean
  order?: number
}

const LiveChat: FC<Props> = ({
  primaryText,
  secondaryText,
  icon,
  recommended,
  withinBusinessHours,
  disabled,
  order = 0
}) => {
  const dispatch = useDispatch()

  return (
    <div style={{ order }}>
      <SupportWidget
        primaryText={primaryText}
        secondaryText={secondaryText}
        icon={icon}
        recommended={recommended && !disabled}
        clickHandler={() => {
          if (withinBusinessHours && !disabled) {
            openChat(dispatch)
          }
        }}
        classes={classNames(
          {
            [styles?.disabledSupportOption]: disabled
          },
          "chatBtn"
        )}
      />
    </div>
  )
}

export default LiveChat
